export default "__VITE_ASSET__CvoymHzA__"